export interface MutationWatcherOptions extends MutationObserverInit {
    maxWaitMs?: number;
}

export function mutationWatcher(
    target: Node,
    options: MutationWatcherOptions,
    callback: (observer:MutationObserver, mutations: MutationRecord[]) => void,
    fallback?: () => void
): () => void {
    const { maxWaitMs, ...observerOptions } = options;

    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    let isStopped = false;

    const observer = new MutationObserver((mutations) => {
        if (isStopped) return;
        callback(observer, mutations);
    });

    const disconnect = () => {
        if (isStopped) return;
        isStopped = true;

        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }

        observer.disconnect();
    };

    if (maxWaitMs !== undefined && maxWaitMs > 0) {
        timeoutId = setTimeout(() => {
            disconnect();
            fallback?.();
        }, maxWaitMs);
    }

    observer.observe(target, observerOptions);

    return disconnect;
}
